module.exports = "/_next/static/images/icon-logout-active-1763f59c.png";